import React from 'react';
import PropTypes from 'prop-types';
import './ScoreProgressBar.css';
import { getScoreColorClass } from 'utils/scoreColors';
import Tooltip from '@mui/material/Tooltip';
const ScoreProgressBar = ({ score }) => {
  // Ensure score is within 0-100 range
  const clampedScore = Math.max(0, Math.min(100, score));

  // Get the color class based on the score
  const scoreColorClass = getScoreColorClass(clampedScore);

  return (
    <div className="score-progress-bar-container">
      <Tooltip
        title={`${clampedScore}%`}
        placement="top"
        disableHoverListener={clampedScore > 6}
        disableTouchListener={clampedScore > 6}
      >
        <div
          className={
            score > 10
              ? `score-progress-bar-fill ${scoreColorClass}`
              : `score-progress-bar-fill-small ${scoreColorClass}`
          }
          style={{ width: `${clampedScore}%` }}
        >
          <span
            className={
              score > 10
                ? 'score-progress-bar-text'
                : 'score-progress-bar-text-small'
            }
          >
            {clampedScore}%
          </span>
        </div>
      </Tooltip>
    </div>
  );
};

export default ScoreProgressBar;
